import Vue from 'vue'
Vue.component('share-ad',()=>import('./share/share-ad.vue'))
Vue.component('ctl-header',()=>import('./header'))
Vue.component('ctl-coach-header',()=>import('./coachHeader'))
Vue.component('ctl-dialog',()=>import('./dialog'))
